<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <dashboard-core-mobile-app-bar v-if="$vuetify.breakpoint.xs" />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./layout/AppBar'),
      DashboardCoreDrawer: () => import('./layout/Drawer'),
      DashboardCoreView: () => import('./layout/View'),
      DashboardCoreMobileAppBar: () => import('./layout/MobileAppBar'),
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
